import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import messages from '../../../locale/messages';
import getAllCancelReason from './getAllCancelReason.graphql';
import CancellationReasonList from '../../../components/SiteAdmin/CancellationReason/CancellationReasonList'
import Loader from '../../../components/Common/Loader/Loader';
import { withQuery } from '../../../hoc/withGraphql';

export class ManageCancelReason extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { cancelReasons, cancelReasons: { loading, getAllCancelReason } } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manageCancelReason)}</h1>
                {!loading && <CancellationReasonList cancelReasons={cancelReasons} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getAllCancelReason, {
        name: 'cancelReasons',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(ManageCancelReason);
